"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
// Relements
var box_1 = __importDefault(require("relements/build/esm/ui/box"));
var button_1 = __importDefault(require("relements/build/esm/ui/button"));
// Components
var FAQUploadModal_1 = __importDefault(require("../FAQUploadModal"));
var ButtonWrapper = styled_components_1["default"](button_1["default"])({
    width: '100%',
    height: '100%',
    margin: 0,
});
var FAQUpload = function (_a) {
    var isEmptyList = _a.isEmptyList, uploadFAQNodes = _a.uploadFAQNodes, downloadFAQNodes = _a.downloadFAQNodes, botId = _a.botId, botTitle = _a.botTitle;
    var _b = react_1.useState(false), showModal = _b[0], setShowModal = _b[1];
    var _c = react_1.useState(false), isDownloadStarted = _c[0], setIsDownloadStarted = _c[1];
    // on Download FAQ Nodes Sheet
    var onDownload = react_1.useCallback(function () {
        setIsDownloadStarted(true);
        downloadFAQNodes(botId, botTitle, function () {
            setIsDownloadStarted(false);
        });
    }, [botId, botTitle, downloadFAQNodes]);
    // on Upload FAQ Nodes
    var onUpload = react_1.useCallback(function (data) {
        uploadFAQNodes(botId, data);
    }, [botId, uploadFAQNodes]);
    return (react_1["default"].createElement(box_1["default"], { padding: "zero", width: "100%", height: "100%" },
        react_1["default"].createElement(ButtonWrapper, { size: "regular", themed: true, onClick: function () { return setShowModal(true); }, variant: isEmptyList ? 'primary' : 'secondary' }, isEmptyList ? 'Bulk Upload FAQ From TSV' : 'Upload FAQs'),
        react_1["default"].createElement(FAQUploadModal_1["default"], { isActive: showModal, isEmptyList: isEmptyList, isDownloadStarted: isDownloadStarted, onClose: function () { return setShowModal(false); }, onDownload: onDownload, onUpload: onUpload, botId: botId })));
};
exports["default"] = FAQUpload;
